import { createSelector } from '@ngrx/store';
import { selectDesign } from '../design.selector';
import { DesignState } from '../design.reducer';
import { CustomImageState } from './custom-image.state';

const selectCustomImageState = createSelector(
  selectDesign,
  (state: DesignState) => state.customImage
);

export namespace fromCustomImageSelectors {
  export const selectCustomImage = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.customImage
  );

  export const selectIsLoading = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.isLoading
  );

  export const selectIsCalibrating = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.isCalibrating
  );

  export const selectCalibrationPointsCount = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.calibrationPointsCount ?? 0
  );

  export const selectIsEditMode = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.isEditMode
  );

  export const selectShowConfirmationDialog = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.showConfirmationDialog
  );

  export const selectDontShowConfirmationAgain = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.dontShowConfirmationAgain
  );

  export const selectUploadError = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.uploadError
  );

  export const selectCalibrationPending = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.calibrationPending
  );

  export const selectCustomImageExists = createSelector(
    selectCustomImage,
    (customImage) => customImage !== null && !customImage.deleted
  );

  export const selectCustomImageOpacity = createSelector(
    selectCustomImage,
    (customImage) => customImage?.opacity ?? 100
  );

  export const selectCustomImageRotation = createSelector(
    selectCustomImage,
    (customImage) => customImage?.rotation ?? 0
  );

  export const selectCustomImageVisible = createSelector(
    selectCustomImage,
    (customImage) => customImage?.visible ?? true
  );

  export const selectCustomImageScale = createSelector(
    selectCustomImage,
    (customImage) => customImage?.scale
  );

  export const selectCustomImagePosition = createSelector(
    selectCustomImage,
    (customImage) => customImage?.position
  );

  export const selectIsMerged = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.isMerged ?? false
  );

  export const selectIsNewImage = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.isNewImage ?? false
  );

  export const selectPreEditSnapshot = createSelector(
    selectCustomImageState,
    (state: CustomImageState) => state?.preEditSnapshot
  );
}
